import { HttpError } from "@refinedev/core";
import axios from "axios";
import Qs from "qs";

const axiosInstance = axios.create({
  paramsSerializer: (params) => {
    return Qs.stringify(params, { arrayFormat: "indices" });
  },
});

axiosInstance.interceptors.request.use((req) => {
  const token = localStorage.getItem("ichigo_admin_token");
  if (token) {
    req.headers = {
      ...req.headers,
      "X-Auth-Token": token,
      "Content-Type": "application/json",
    };
  }
  return req;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let errors = "An error occurred while processing your request";

    // Only extract safe error information from the response
    if (error.response?.data?.error) {
      if (typeof error.response.data.error === "string") {
        errors = error.response.data.error;
      } else if (error.response.data.error?.message) {
        errors = error.response.data.error.message;
      } else {
        const errorEntries = Object.entries(error.response.data.error).map(
          ([key, val]) => {
            if (Array.isArray(val)) {
              return `${key}: ${val.join(" | ")}`;
            }
            if (typeof val === "string") {
              return `${key}: ${val}`;
            }
            return `${key}: ${JSON.stringify(val)}`;
          },
        );
        errors = errorEntries.join(". ");
      }
    } else if (error.response?.data?.errors) {
      if (typeof error.response.data.errors === "string") {
        errors = error.response.data.errors;
      } else if (Array.isArray(error.response.data.errors)) {
        errors = error.response.data.errors.join(" | ");
      } else {
        errors = JSON.stringify(error.response.data.errors);
      }
    } else if (error.response?.data?.message) {
      errors = error.response.data.message;
    }

    // Create a clean error object without exposing internal details
    const customError: HttpError = {
      message: errors,
      statusCode: error.response?.status || 500,
      // Only include safe properties, avoid spreading the entire error object
    };

    // Log detailed error information for debugging (server-side only)
    if (process.env.NODE_ENV === "development") {
      console.error("API Error Details:", {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        message: errors,
      });
    }

    return Promise.reject(customError);
  },
);

export default axiosInstance;
